module.exports = __webpack_public_path__ + "img/lock-unlocked.2dbfabdd.svg";